
  <input
    ssFormInput
    [value]="valueSubject | async"
    matInput
    [type]="(hideTextSubject | async) ? 'password' : 'text'"
    #inputRef
  />


